/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
import { storageUtils } from '@oh-vcp/components-common';
import React, { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { UrlService } from '@oh-vcp/components-ui';
import CaseService from '../services/caseService';
import useFileService from '../services/useFileService';
import apiService from '../services/apiService';
import useCanAccessFileService from '../services/useCanAccessFileService';

const EconsultFileDownload = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const hasDownloadedRef = React.useRef(false);
  const { data: fileDetails } = useFileService(id ? parseInt(id, 10) : undefined);
  const { fetchCanAccessById } = useCanAccessFileService();

  const fileAccessKey = UrlService.getParamIgnoreCase(searchParams, 'fileaccesskey');

  const downloadAttachment = async (fileId: string | undefined, fileName: string | undefined) => {
    if (!fileId || !fileName) return;
    const canAccessFile = await fetchCanAccessById(fileId);
    if (!canAccessFile || !canAccessFile.access) {
      window.alert('Error: you do not have permission to view this file!');
      return;
    }
    const fileUrl = await CaseService.getFileUrl(fileId);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const downloadAttachmentWithFileAccessKey = async (fileId: string | undefined) => {
    if (!fileId) return;
    const token = storageUtils.getUserToken();
    if (token) {
      const canAccessFile = await fetchCanAccessById(fileId);
      if (!canAccessFile || !canAccessFile.access) {
        window.alert('Error: you do not have permission to view this file!');
        return;
      }
      const fileUrl = `/files/${fileId}?api_access_token=${token}&file_access_key=${fileAccessKey}`;
      const response = await apiService.get(fileUrl, { responseType: 'blob' });
      if (response && response.data) {
        const contentDisposition = response.headers['content-disposition'];

        let fileName = 'downloaded-file';

        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*?=(?:['"]?)(.+?)(?:['"]?$)/i);
          if (match && match[1]) {
            fileName = match[1];
          }
        }
        const blob = new Blob([response.data]);
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    }
  };

  useEffect(() => {
    if (hasDownloadedRef.current) return;
    if (fileAccessKey && id) {
      downloadAttachmentWithFileAccessKey(id);
      hasDownloadedRef.current = true;
    } else if (fileDetails && id) {
      downloadAttachment(id?.toString(), fileDetails.fileName);
      hasDownloadedRef.current = true;
    }
  }, [fileDetails, id, fileAccessKey]);

  return null;
};

export default EconsultFileDownload;
